import CheckIcon from '@mui/icons-material/Check';
import { Stack } from '@mui/material';
import { StyledToggleButtonGroup, StyledToggleButton, ToggleLabel } from './styles';

interface ToggleGroupProps<T> {
  value: T;
  onChange: (exposureType: T) => void;
  options: { label: string; value: T }[];
}

function ToggleGroup<T extends string | number>({ value, onChange, options }: ToggleGroupProps<T>) {
  return (
    <StyledToggleButtonGroup
      value={value}
      exclusive
      onChange={(_, value) => {
        if (value !== null) {
          onChange(value as T);
        }
      }}
    >
      {options.map((option) => (
        <StyledToggleButton key={String(option.value)} value={option.value}>
          <Stack direction="row" alignItems="center" gap={0.5} component="span">
            {value === option.value ? <CheckIcon sx={{ fontSize: '1rem' }} /> : null}
            <ToggleLabel>{option.label}</ToggleLabel>
          </Stack>
        </StyledToggleButton>
      ))}
    </StyledToggleButtonGroup>
  );
}
export default ToggleGroup;
